<template>
  <v-dialog v-model="edits.songModal" width="600" :persistent="true">
    <v-card>
      <v-card-title class="black">
        <h2 class="pl-2 text-uppercase font-weight-light">
          {{title}}
        </h2>
      </v-card-title>

      <v-card-text>
        <v-layout wrap>
          <v-flex xs12>
            <v-layout row>
            <v-autocomplete
              class="mb-4"
              label="Artist"
              :items="$database.artists.array"
              v-model="formData.artist_id"
              item-text="ac"
              item-value="id"
              color="secondary"
              :hide-details="true"
              placeholder="Search for Artists by Name"
              :disabled="busy"
              :rules="rules.artist_id"
              :menu-props="{contentClass: 'text-uppercase'}"/>
            <v-btn icon dense color="secondary black--text" :disabled="artistIsEmpty" @click="$emit('edit-artist', selectedArtist)">
              <v-icon>fa-pen</v-icon>
            </v-btn>
            <v-btn icon dense color="secondary black--text"  @click="$emit('edit-artist', null)">
              <v-icon>fa-plus</v-icon>
            </v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Song Title *"
              color="secondary"
              v-model="formData.title"
              :rules="rules.title"
              :disabled="busy"
              hint='Original language. E.g., Japanese characters for Japanese titles.'/>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Song Title (Alternate)"
              color="secondary"
              v-model="formData.original_title"
              :disabled="busy"
              hint='Optional. Romanized or translated versions of non-English titles or other titles the song is known as.'/>
          </v-flex>
          <v-flex xs12>
            <v-select
              :items="genres"
              label="Genre *"
              v-model="formData.genre"
              item-text="name"
              item-value="id"
              color="secondary"
              :disabled="busy"
              :rules="rules.genre"/>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Social Media Query"
              color="secondary"
              v-model="formData.social_media_query"
              :disabled="busy"
              hint='Optional. Used when the default query for video does not return appropriate results.'/>
          </v-flex>
        </v-layout>
        <br/><small class="ml-2">* Required fields</small>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-progress-circular indeterminate v-if="busy"></v-progress-circular>
          <v-btn color="secondary" flat @click="close()" :disabled="busy">Close</v-btn>
          <v-btn color="secondary black--text" @click="submit()" :disabled="busy">Save Song</v-btn>
        </div>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>

import { setSongArtist, setSongAutocomplete } from '../services/database'

import GENRES from '../constants/genres'

export default {
  name: 'song-edit-modal',
  props: {
    edits: Object
  },
  data () {
    return {
      busy: false,
      genres: GENRES,
      formData: {
        artist_id: null,
        title: null,
        original_title: null,
        genre: null,
        social_media_query: null
      },
      rules: {
        artist_id: [
          v => !!v || 'Artist is required.'
        ],
        title: [
          v => !!v || 'Title is required.'
        ],
        genre: [
          v => !!v || 'Genre is required.'
        ]
      }
    }
  },
  computed: {
    title () {
      if (this.edits.song) {
        return `Edit Song: ${this.edits.song.t}`
      }
      return `Create Song`
    },
    artistIsEmpty () {
      return !this.formData.artist_id
    },
    selectedArtist () {
      return this.artistIsEmpty ? null : this.$database.artists.get(this.formData.artist_id)
    }
  },
  methods: {
    refreshData () {
      var song = this.edits.song
      if (song) {
        this.formData.artist_id = song.art
        this.formData.title = song.t
        this.formData.original_title = song.ot
        this.formData.genre = song.g
        this.formData.social_media_query = song.q
      } else {
        this.resetData()
      }
    },
    resetData () {
      this.formData.artist_id = null
      this.formData.title = null
      this.formData.original_title = null
      this.formData.genre = null
      this.formData.social_media_query = null
    },
    submit () {
      this.busy = true
      var promise
      var song = this.edits.song
      if (song && song.id) {
        promise = this.$api.songs.update(song.id, this.formData)
      } else {
        promise = this.$api.songs.create(this.formData)
      }
      return promise.then(savedSong => {
        var song = this.$database.songs.update(savedSong)
        setSongArtist(song)
        setSongAutocomplete(song)
        this.close()
        this.busy = false
      }).catch(error => {
        console.log(error)
        this.busy = false
      })
    },
    close () {
      this.edits.songModal = false
    }
  },
  watch: {
    'edits.songModal': function (val) {
      if (val === true) {
        this.refreshData()
      } else {
        this.resetData()
        this.edits.song = null
      }
    }
  }
}
</script>
